import axios from "axios";
import * as actionType from "../../constant/actionType";

export const GetAllProvidersCountOfClient = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/client/GetAllProvidersCountOfClient`,
        params: apiData,
      });
      return response.data
    //   dispatch(fetchDataSuccess(response.data));
    } catch (error) {
        return error.message
    //   dispatch(fetchDataError(error.message));
    }
  };
